import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
/*
 * @Author: 刘怡
 * @Date: 2022-04-13 14:50:27
 * @Last Modified by: 刘怡
 * @Last Modified time: 2023-01-11 16:12:09
 */
import { message } from 'ant-design-vue';
import { getCountryAndCurrencyInfo } from '@/api/user';
// import moment from 'moment';

/**
 * @description 国际化：日期格式化
 * @param {*} format 日期格式
 * @param {*} a 是否显示上午下午
 * @returns {String} 客户业务所在地日期格式
 */
export function i18nFormatDate(format, a = '') {
  let _separator = format.includes('-') ? '-' : '/';
  let newValue = format.split(_separator);
  let _format = '';
  _format = newValue.map(item => {
    if (item.includes('Y')) {
      item = item.replace('Y', 'YYYY');
    } else if (item.includes('y')) {
      item = item.replace('y', 'YY');
    } else if (item.includes('m')) {
      item = item.replace('m', 'MM');
    } else if (item.includes('M')) {
      item = item.replace('M', 'MMM');
    } else if (item.includes('n')) {
      item = item.replace('n', 'M');
    } else if (item.includes('d')) {
      item = item.replace('d', 'DD');
    }
    return item;
  }).join(_separator);
  if (a) {
    _format += ' a';
  }
  return _format;
}
export function getFormatDate() {
  let info = JSON.parse(sessionStorage.getItem('countryAndCurrencyInfo'));
  return i18nFormatDate(info === null || info === void 0 ? void 0 : info.countryInfo.dateFormat);
}
export function dateChronaxie() {
  let info = JSON.parse(sessionStorage.getItem('countryAndCurrencyInfo'));
  return (info === null || info === void 0 ? void 0 : info.countryInfo.chronaxie) == '12时' ? 'a' : '';
}
/**
 * @description 国际化：货币单位
 * @param {*} format 日期格式
 * @returns {String} 货币单位、符号
 */
export function i18nCurrencyUnit(isCustomer = false, isDefault = true) {
  let info = isCustomer || isDefault ? JSON.parse(sessionStorage.getItem('countryAndCurrencyInfo')) : JSON.parse(sessionStorage.getItem('countryAndCurrencyInfo2'));
  if (isCustomer) {
    return (info === null || info === void 0 ? void 0 : info.currencyInfo.code) || '';
  } else {
    return (info === null || info === void 0 ? void 0 : info.currencyInfo.unit) || '元';
  }
}
export function countryAndCurrencyInfo(customerId, key = 'customerId') {
  let obj = {};
  obj[key] = customerId;
  return new Promise((resolve, reject) => {
    getCountryAndCurrencyInfo(obj).then(res => {
      sessionStorage.setItem('countryAndCurrencyInfo2', JSON.stringify(res));
      resolve(res);
    });
  });
}

/**
 * @description 文件下载
 * @param {*} data 文件流
 * @param {*} type 文件类型
 * @param {*} name 文件名字
 * @returns
 */
export function downloadFileFun(data, type, name) {
  let a = document.createElement('a');
  let blob = new Blob([data], {
    type: type
  });
  let objectUrl = URL.createObjectURL(blob);
  a.setAttribute('href', objectUrl);
  // let nowDate = new Date();
  // let time=nowDate.getFullYear()+'-'+Number(Number(nowDate.getMonth()) + 1)+'-'+nowDate.getDate();
  a.setAttribute('download', name);
  a.click();
}
/**
 * 排序
 */
export function func(a, b) {
  return a.sort - b.sort;
}
/**
 * 时间获取
 * @param { string } code  // return val=='WEEK'?'本周':val=='MONTH'?'本月':val=='MARCH'?'近三月':val=='YEAR'?'本年':'';
 * @returns { Object }
 */
export function getDate(code) {
  const date = new Date();
  // const date = new Date(
  //   new Date().getTime() - 24 * 60 * 60 * 1000
  // );
  let endTime = formatTime(date);
  let date1 = Date.parse(date);
  let start = '';
  let end = '';
  let oneDay = 1000 * 3600 * 24;
  switch (code) {
    //本周
    case 'WEEK':
      // let today = new Date(date);
      let todayDay = date.getDay() || 7;
      start = new Date(date.getTime() - oneDay * (todayDay - 1));
      // let a = 6 - date.getDay()===1? 0 : date.getDay() - 6;
      // console.log( a,22);
      // start = new Date(date1 + oneDay * a).setHours(0, 0, 0, 0);
      end = new Date(date1 + oneDay * (date.getDay() === 1 ? 5 : 6 - date.getDay())).setHours(24, 0, 0, 0);
      break;
    //本月
    case 'MONTH':
      start = new Date();
      start.setHours(0, 0, 0, 0);
      start.setMonth(start.getMonth(), 1);
      end = new Date(start);
      end.setHours(24, 0, 0, 0);
      end.setMonth(start.getMonth(), new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate());
      break;
    //最近3月
    case 'MARCH':
      start = new Date();
      start.setMonth(start.getMonth() - 3);
      break;
    //本年
    case 'YEAR':
      start = new Date();
      start.setHours(0, 0, 0, 0);
      start.setMonth(0, 1);
      start.setYear(start.getFullYear());
      end = new Date(start);
      end.setHours(24, 0, 0, 0);
      end.setMonth(11, 31);
      end.setYear(start.getFullYear());
      break;
  }
  return {
    startTime: formatTime(new Date(start)),
    // endTime:endTime
    endTime: end ? formatTime(new Date(end)) : endTime
  };
}
function formatTime(param) {
  let y = param.getFullYear();
  let m = param.getMonth() + 1;
  let d = param.getDate();
  m = m < 10 ? '0' + m : m;
  d = d < 10 ? '0' + d : d;
  return y + '-' + m + '-' + d + ' ';
}
export function clickCopy(msg) {
  const save = function (e) {
    e.clipboardData.setData('text/plain', msg);
    e.preventDefault(); // 阻止默认行为
  };
  const once = {
    once: true
  };
  document.addEventListener('copy', save, once); // 添加一个copy事件,当触发时执行一次,执行完删除
  document.execCommand('copy'); // 执行copy方法
  message.destroy();
  message.success(window.vm.$i18n.t('复制成功'));
}

/**
 * 货币分隔符
 * @param {string} m 需要转换的字符串
 * @param {number} icon 分隔符号，默认
 * @param {number} p 分隔符位数，默认 3
 */
export const formatMoney = (m, icon, p = 3) => {
  let newM = m.slice(0, m.length % p) + (m.length % p ? icon : '') + m.slice(m.length % p).replace(new RegExp(`\\d{${p}}`, 'g'), (n, i) => (i ? icon : '') + n);
  return newM;
};
//图表颜色控制
export const COLORLIST = ['#C15FFF', '#003366', '#F6D06F', '#4FD8FF', '#FF5F55', '#FFC935', '#767BFB', 'rgb(248,70,102)', '#5171fd', '#42d79b', '#303133', '#CCCC66', '#990000', '#663333', '#99FFFF', '#00FF66', '#CC99FF', '#666699'];

// 获取数字+大小写字母随机数
export const randomLetterNumber = digit => {
  let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
  let res = '';
  for (var i = 0; i < digit; i++) {
    var id = Math.ceil(Math.random() * 61);
    res += chars[id];
  }
  return res;
};
// 获取数字随机数
export const randomNumber = digit => {
  let nub = '';
  for (let i = 0; i < digit; i++) {
    // eslint-disable-next-line no-unused-vars
    nub += Math.floor(Math.random() * 10);
  }
  return nub;
};
export const LANGUAGE_RESOURCE = {
  zh_CN: 'zh',
  zh_TW: 'cht',
  en_US: 'en',
  fr_FR: 'fra',
  ru_RU: 'ru',
  es_ES: 'spa'
};

/**
 * @description 通过url下载文件
 * @param {*} url 下载链接
 * @param {*} name 文件名字
 * @returns
 */

export function downloadFileByUrl(url, name) {
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = url;
  if (name) {
    link.setAttribute('download', name);
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link); // 下载完成移除元素
  window.URL.revokeObjectURL(url); // 释放掉blob对象
}